/* eslint-disable */
'use strict';
import Wix from 'Wix';
import { reduce, zip } from 'lodash';

var wixService = function () {
    var wix = Wix;
    var url;
    wix.Utils = wix.Utils || {};
    wix.Utils.getInstance = function () {
        url = window.location.search;
        var instanceRegexp = /.instance=([\[\]a-zA-Z0-9\.\-_]*?)(&|$|#)./g;
        var instance = instanceRegexp.exec(url);
        return (instance && instance[1]) ? instance[1] : undefined;
    };
    
    wix.getParamFromURL = function (name) {
        var val;
        var url =  window.location.search;
        try {
          val = new URLSearchParams(url).get(name);
        } catch (err) {
          name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
          var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
          var results = regex.exec(url);
    
          val = results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
        }
    
        return val;
      };

	wix.isPremium = function(){
	    return  wix.Utils.getInstanceValue('vendorProductId') !== null;
	};
	
    wix.isMobile = function () {
        return (wix.Utils.getDeviceType() == "mobile");
    };

    wix.isEditorMode = function () {
        return (wix.Utils.getViewMode() == "editor");
    };

    wix.isSiteMode = function () {
        return (wix.Utils.getViewMode() == "site");
    };

    wix.isPreviewMode = function () {
        return (wix.Utils.getViewMode() == "preview");
    };

    wix.isIOS = function () {
        var userAgent = navigator.userAgent.toLowerCase(),
            isIPhone = (userAgent.indexOf("iphone") >= 0),
            isIPod = (userAgent.indexOf("ipod") >= 0),
            isIPad = (userAgent.indexOf("ipad") >= 0);

        return (isIPhone || isIPod || isIPad);
    };

    wix.isIPhone = function () {
        var userAgent = navigator.userAgent.toLowerCase(),
            isIPhone = (userAgent.indexOf("iphone") >= 0);

        return (isIPhone);
    };

    wix.isIpad = function () {
        var userAgent = navigator.userAgent.toLowerCase(),
            isIPad = (userAgent.indexOf("ipad") >= 0);

        return (isIPad);
    };

    wix.applicationLoaded = function() {
        return Wix.Performance.applicationLoaded();
    }

    wix.applicationLoadingStep = function(stageNumber, stageDescription) {
        stageDescription = stageDescription || "";
        Wix.Performance.applicationLoadingStep(stageNumber, stageDescription);
    }
    
    const xor = (str, key) => {
        if (!str || !key) {
            return null;
        }
        return reduce(zip(str.split(''), key.split('')), (acc, [a, b]) => {
            a = parseInt(a, 16);
            b = parseInt(b, 16);
            if (!isNaN(a) && !isNaN(b)) {
                return acc + (a ^ b).toString(16); // eslint-disable-line no-bitwise
            }
            return `${acc}-`;
        }, '');
    };

    wix.getAppIds = function () {
        const instanceId = Wix.Utils.getInstanceId();
        const biToken = Wix.Utils.getInstanceValue('biToken');
        const metaSiteId = xor(instanceId, biToken);
        return { instanceId, metaSiteId, biToken};
    };
    return wix;
};
export default wixService();

/* eslint-enable */



// WEBPACK FOOTER //
// ./src/utils/wixService.js